import { render, staticRenderFns } from "./notifydetails.vue?vue&type=template&id=3dd283b1&scoped=true"
import script from "./notifydetails.vue?vue&type=script&lang=js"
export * from "./notifydetails.vue?vue&type=script&lang=js"
import style0 from "./notifydetails.vue?vue&type=style&index=0&id=3dd283b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd283b1",
  null
  
)

export default component.exports